const TRANSPORT_MODES = [
  { id: 'walking', title: 'Te voet' },
  { id: 'bike', title: 'Fiets' },
  { id: 'e-bike', title: 'E-Bike' },
  { id: 'car', title: 'Auto', pro: true },
  { id: 'ov', title: 'Trein, tram of bus' },
  { id: 'bike_ov', title: 'Fiets + trein/tram/bus' },
  { id: 'car_ov', title: 'Auto + trein/tram/bus', pro: true },
];

export { TRANSPORT_MODES };
